export const AdviceTypes = [
  {id: 1, name:  "اولین بار اپ را باز کرده (firstAppOpened)"},
  {id: 2, name: "عمومی (general)"},
  {id: 3, name: " پریود (period)"},
  {id: 4, name: "فاز لوتئال (luteal)"},
  {id: 5, name: "فاز فولیکولار (follicular"},
  {id: 6, name: "تخمک گذاری (Ovulation)"},
  {id: 7, name: "همراه (Partner)"},
  {id: 8, name: "زن (Female)"},
  {id: 9, name: "مرد (Male)"},
  {id: 10, name: "بارداری (Pregnancy)"},
];

export const AdviceFilterTypes = [
  {name: "اولین بار اپ را باز کرده (firstAppOpened)", value: 1},
  {name: "عمومی (general)", value: 2},
  {name: "پریود (period)", value: 3},
  {name: "فاز لوتئال (luteal)", value: 4},
  {name: "فاز فولیکولار (follicular)", value: 5},
  {name: "تخمک گذاری (Ovulation)", value: 6},
  {name: "همراه (Partner)", value: 7},
  {name: "زن (Female)", value: 8},
  {name: "مرد (Male)", value: 9},
  {name: "بارداری (Pregnancy)", value: 10},
];

export const AdviceFilterConditions = [
  {name: "Yes", value: true},
  {name: "No", value: false}
];